import { render, staticRenderFns } from "./SupplierReplyReview.vue?vue&type=template&id=f2c65dae&"
import script from "./SupplierReplyReview.vue?vue&type=script&lang=js&"
export * from "./SupplierReplyReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports